import { Eyebrow } from "@/components/Eyebrow";
import { cn } from "@/lib/cn";
import { SPACE_BELOW, type SpaceBelow } from "@/lib/rhythm";
import type { ReactNode } from "react";

export function FormCard({
  children,
  spaceBelow = "normal",
}: {
  children: ReactNode;
  spaceBelow?: SpaceBelow;
}) {
  return (
    <div
      className={cn(
        "relative z-10 mx-4 -mt-56 max-w-4xl rounded-card bg-primary px-4 py-8 sm:mx-8 sm:-mt-24 md:px-6 lg:mx-auto lg:w-full md:py-16 lg:-mt-40 lg:px-28 lg:py-32",
        SPACE_BELOW[spaceBelow],
      )}
    >
      <div className="mx-auto flex max-w-2xl flex-col gap-12 md:gap-16">
        {children}
      </div>
    </div>
  );
}

export function FormSection({
  eyebrow,
  children,
}: {
  eyebrow: string;
  children: ReactNode;
}) {
  return (
    <section className="flex flex-col gap-6">
      <Eyebrow as="h2">{eyebrow}</Eyebrow>
      <div className="flex flex-col gap-10">{children}</div>
    </section>
  );
}

export function FormRow({ children }: { children: ReactNode }) {
  return (
    <div className="flex flex-col gap-10 sm:flex-row sm:gap-6">{children}</div>
  );
}
